"use client";
import Recommendations from "@/app/ec/product/recommendations/recommendations";
import { RecentlyViewedItems } from "@/components/recentlyViewedItems/recentlyViewedItems";
import styles from "./individualCategoryRecommendations.module.scss";

type Props = {
  categoryDetails: CategoryDetails;
};

const IndividualCategoryRecommendations = ({ categoryDetails }: Props) => {
  const category = categoryDetails.name;
  return (
    <>
      <Recommendations
        className={styles.recommendations}
        modelParams={{
          fallbackParameters: {
            query: category,
            filters: `categoryPageId:"${category}" AND availability:Y`,
          },
          queryParameters: {
            filters: `categoryPageId:"${category}" AND availability:Y`,
          },
        }}
        title={`Best Sellers in ${category}`}
        model="trending-items"
      />
      <Recommendations
        className={styles.recommendations}
        modelParams={{
          fallbackParameters: {
            query: category,
            filters: `categoryPageId:"${category}" AND general_rating > 4 AND availability:Y`,
          },
          queryParameters: {
            filters: `categoryPageId:"${category}" AND general_rating > 4 AND availability:Y`,
          },
        }}
        title={`Top Rated in ${category}`}
        model="trending-items"
        orderBy={["general_rating", "number_of_general_ratings"]}
      />
      <RecentlyViewedItems />
    </>
  );
};

export default IndividualCategoryRecommendations;
